module.exports = new __parcel__URL__("airmail.0c6f5ae0.png").toString();